import useUserNavigationUtils from "@hooks/useUserNavigationUtils"

import { faIcon } from "@utils/faIcon"

import SideBarItem from "@organisms/SideBar/components/SideBarItem/SideBarItem"

export default function HelpCenter() {
    const { openHelpCenter } = useUserNavigationUtils()

    return (
        <SideBarItem
            onClick={() => openHelpCenter()}
            label="Help Center"
            icon={faIcon({ name: "circle-question", style: "regular" })}
            iconActive={faIcon({ name: "circle-question", style: "solid" })}
        />
    )
}
